import React, { useCallback } from 'react';
import Image from 'react-bootstrap/Image';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import DefaultOrgLogo from '../../assets/images/DefaultOrgLogo.svg';
import baseServerUrl from '../../services/apiServer';
import Button from '../shared/Button/Button';

import styles from './PublicHeader.module.scss';

const PublicHeader = ({ organizationName, logo }) => {
  const { t } = useTranslation('common');
  const currentUser = useSelector((state) => state.authReducer.currentUser);
  const displayName = organizationName || t('organizationNameDefault');
  const authenticated = !!currentUser;

  const handleJoinPress = useCallback(() => {
    window.location.href = `${baseServerUrl}/signup`;
  }, []);

  const handleLoginPress = useCallback(() => {
    window.location.href = `${baseServerUrl}/login`;
  }, []);

  return (
    <div className={styles.headerContainer}>
      <div className={styles.flexDisplay}>
        <Image src={logo ?? DefaultOrgLogo} alt="company logo" className={styles.logo} />
        <div className={styles.organizationName}>{displayName}</div>
      </div>
      {!authenticated && (
        <div className={styles.buttonsContainer}>
          <Button variant="outline-secondary" onClick={handleLoginPress}>
            {t('login')}
          </Button>
          <Button variant="outline-primary" onClick={handleJoinPress}>
            {t('join')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default PublicHeader;
